<template>
  <div class="is-marginless is-paddingless section section-details" v-if="remiseBancaireEdit">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="$router.go(-1)"
               class="button is-cancel btn-modal-annuler">
              {{ $t('general.button.return')}}
            </a>
            <button class="button is-addOrEdit" v-if="remiseBancaire.etat === constantes.ENCOURS"
                    @click="save(false)">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :error="error"
                         class="mgt-20px"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :title="'editionClient.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <app-remise-bancaire :isDetail="false"
                         :detailRemiseBancaire="detailRemiseBancaire"
                         :remiseBancaire="remiseBancaireEdit"
                         @updateMouvementClient="updateMouvementClient"
                         @editReglementByPiece="checkChangementBeforeEditReglementByPiece">
    </app-remise-bancaire>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention :messHeader="$t('modifRemiseBancaire.popUpPrevention.messHeader')"
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('modifRemiseBancaire.popUpPrevention.actions.goWithoutSave')"
                         :otherButton="$t('modifRemiseBancaire.popUpPrevention.actions.goWithSave')"
                         @otherButtonSelect="save(true)"
                         @yes="$router.push({
                         name: 'm.bodac.remises_bancaires', params: reglement })"
                         @no="popUpPrevention = false">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import translate from '@/services/remiseBancaire/validation/champsRemiseBancaireTranslator';
import formatDate from '@/services/general/formatIsoDate';
import { update, get } from '@/api/remiseBancaire';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import { getByRemiseBancaire } from '@/api/mouvementClient/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import { SENS_VENTE } from '@/configuration/devisConf';
import { ENCOURS } from '@/configuration/remiseBancaire/remiseBancaireConf';
import appRemiseBancaire from '@/components/remiseBancaire/remiseBancaire';
import popUpPrevention from '@/components/general/popUpPrevention';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  data() {
    return {
      remiseBancaire: null,
      detailRemiseBancaire: [],
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      remiseBancaireEdit: null,
      popUpPrevention: false,
      reglement: null,
      constantes: {
        ENCOURS,
      },
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    appRemiseBancaire,
    popUpPrevention,
    errorMsgComponent,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('modifRemiseBancaire.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('modifRemiseBancaire.breadcrumb.liste'), route: { name: 'l.bodac.remises_bancaires' }, isActive: false },
        { title: this.$t('modifRemiseBancaire.breadcrumb.modif'), route: { name: '' }, isActive: true },
      ];
    },
    getTitle() {
      return this.$i18n.t('modifRemiseBancaire.title') + formatCodeRemiseBancaire(
        this.remiseBancaire.num, this.remiseBancaire.nom, SENS_VENTE,
      );
    },
  },
  methods: {
    async updateMouvementClient() {
      const detailRemiseBancaire = (await getByRemiseBancaire(this.remiseBancaire.id)).data.result;
      detailRemiseBancaire.forEach((el) => {
        el.selected = false;
      });
      this.detailRemiseBancaire = detailRemiseBancaire;
    },
    async checkChangementBeforeEditReglementByPiece(reglement) {
      this.reglement = cloneDeep(reglement);
      if (moment(this.remiseBancaireEdit.dateRemise)
        .diff(moment(this.remiseBancaire.dateRemise), 'days') !== 0
        || this.remiseBancaireEdit.modeReglementId !== this.remiseBancaire.modeReglementId
        || this.remiseBancaireEdit.domiciliationBancaireId
        !== this.remiseBancaire.domiciliationBancaireId) {
        this.popUpPrevention = true;
      } else await this.$router.push({ name: 'm.bodac.remises_bancaires-piece', params: this.reglement });
    },
    async save(editReglement) {
      const loadingComponent = this.$buefy.loading.open();
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.error = false;
      this.messages = [];
      this.popUpPrevention = false;
      try {
        const remiseBancaire = cloneDeep(this.remiseBancaireEdit);
        remiseBancaire.dateRemise = formatDate(remiseBancaire.dateRemise);
        await update(remiseBancaire);
        messageSucces(this.$t('remiseBancaire.messages.successUpdate'));
        if (editReglement) {
          await this.$router.push({ name: 'm.bodac.remises_bancaires', params: this.reglement });
        } else await this.$router.push({ name: 'c.bodac.remises_bancaires', params: { id: remiseBancaire.id } });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    const id = this.$route.params.id;
    try {
      this.remiseBancaire = (await get(id)).data.result;
      this.remiseBancaire.dateRemise = new Date(this.remiseBancaire.dateRemise);
      this.remiseBancaireEdit = cloneDeep(this.remiseBancaire);
      await this.updateMouvementClient();
      this.setInformationPage(this.$t('pageGeneral.modification', { item: formatCodeRemiseBancaire(this.remiseBancaire.num, this.remiseBancaire.nom, SENS_VENTE) }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
